/* tslint:disable */
/* eslint-disable */
/**
 * Universal Process API
 * Universal Process App API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ResourceNoteCreationRequestDto } from '../models';
// @ts-ignore
import type { ResourceNoteIdDto } from '../models';
// @ts-ignore
import type { ResourceTypeDto } from '../models';
/**
 * RestResourcesNoteApi - axios parameter creator
 */
export const RestResourcesNoteApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} resourceId 
         * @param {ResourceTypeDto} resourceType 
         * @param {ResourceNoteCreationRequestDto} resourceNoteCreationRequestDto Resource note creation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addNote: async (resourceId: string, resourceType: ResourceTypeDto, resourceNoteCreationRequestDto: ResourceNoteCreationRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('addNote', 'resourceId', resourceId)
            // verify required parameter 'resourceType' is not null or undefined
            assertParamExists('addNote', 'resourceType', resourceType)
            // verify required parameter 'resourceNoteCreationRequestDto' is not null or undefined
            assertParamExists('addNote', 'resourceNoteCreationRequestDto', resourceNoteCreationRequestDto)
            const localVarPath = `/api/resources/{resourceId}/notes`
                .replace('{resourceId}', encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (resourceType !== undefined) {
                localVarQueryParameter['resourceType'] = resourceType;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resourceNoteCreationRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} resourceId 
         * @param {ResourceTypeDto} resourceType 
         * @param {number} noteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeNote: async (resourceId: string, resourceType: ResourceTypeDto, noteId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('removeNote', 'resourceId', resourceId)
            // verify required parameter 'resourceType' is not null or undefined
            assertParamExists('removeNote', 'resourceType', resourceType)
            // verify required parameter 'noteId' is not null or undefined
            assertParamExists('removeNote', 'noteId', noteId)
            const localVarPath = `/api/resources/{resourceId}/notes/{noteId}`
                .replace('{resourceId}', encodeURIComponent(String(resourceId)))
                .replace('{noteId}', encodeURIComponent(String(noteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (resourceType !== undefined) {
                localVarQueryParameter['resourceType'] = resourceType;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestResourcesNoteApi - functional programming interface
 */
export const RestResourcesNoteApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestResourcesNoteApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} resourceId 
         * @param {ResourceTypeDto} resourceType 
         * @param {ResourceNoteCreationRequestDto} resourceNoteCreationRequestDto Resource note creation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addNote(resourceId: string, resourceType: ResourceTypeDto, resourceNoteCreationRequestDto: ResourceNoteCreationRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResourceNoteIdDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addNote(resourceId, resourceType, resourceNoteCreationRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestResourcesNoteApi.addNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} resourceId 
         * @param {ResourceTypeDto} resourceType 
         * @param {number} noteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeNote(resourceId: string, resourceType: ResourceTypeDto, noteId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeNote(resourceId, resourceType, noteId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestResourcesNoteApi.removeNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestResourcesNoteApi - factory interface
 */
export const RestResourcesNoteApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestResourcesNoteApiFp(configuration)
    return {
        /**
         * 
         * @param {string} resourceId 
         * @param {ResourceTypeDto} resourceType 
         * @param {ResourceNoteCreationRequestDto} resourceNoteCreationRequestDto Resource note creation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addNote(resourceId: string, resourceType: ResourceTypeDto, resourceNoteCreationRequestDto: ResourceNoteCreationRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ResourceNoteIdDto> {
            return localVarFp.addNote(resourceId, resourceType, resourceNoteCreationRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} resourceId 
         * @param {ResourceTypeDto} resourceType 
         * @param {number} noteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeNote(resourceId: string, resourceType: ResourceTypeDto, noteId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeNote(resourceId, resourceType, noteId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestResourcesNoteApi - interface
 */
export interface RestResourcesNoteApiInterface {
    /**
     * 
     * @param {string} resourceId 
     * @param {ResourceTypeDto} resourceType 
     * @param {ResourceNoteCreationRequestDto} resourceNoteCreationRequestDto Resource note creation request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addNote(resourceId: string, resourceType: ResourceTypeDto, resourceNoteCreationRequestDto: ResourceNoteCreationRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ResourceNoteIdDto>;

    /**
     * 
     * @param {string} resourceId 
     * @param {ResourceTypeDto} resourceType 
     * @param {number} noteId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeNote(resourceId: string, resourceType: ResourceTypeDto, noteId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * RestResourcesNoteApi - object-oriented interface
 */
export class RestResourcesNoteApi extends BaseAPI implements RestResourcesNoteApiInterface {
    /**
     * 
     * @param {string} resourceId 
     * @param {ResourceTypeDto} resourceType 
     * @param {ResourceNoteCreationRequestDto} resourceNoteCreationRequestDto Resource note creation request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addNote(resourceId: string, resourceType: ResourceTypeDto, resourceNoteCreationRequestDto: ResourceNoteCreationRequestDto, options?: RawAxiosRequestConfig) {
        return RestResourcesNoteApiFp(this.configuration).addNote(resourceId, resourceType, resourceNoteCreationRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} resourceId 
     * @param {ResourceTypeDto} resourceType 
     * @param {number} noteId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public removeNote(resourceId: string, resourceType: ResourceTypeDto, noteId: number, options?: RawAxiosRequestConfig) {
        return RestResourcesNoteApiFp(this.configuration).removeNote(resourceId, resourceType, noteId, options).then((request) => request(this.axios, this.basePath));
    }
}

